import React from "react";

/**
 * Page content width constraint.
 */
const Container = ({ children, className = "", as: Tag = "div" }) => {
  return <Tag className={`container ${className}`.trim()}>{children}</Tag>;
};

export default Container;
